import { Component, OnDestroy, OnInit } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/auth/auth.service';
import { twoFactorErrorMessage } from 'src/app/auth/two-factor/two-factor-errors';
import { Roles } from 'src/app/shared/models/auth/role.model';
import { FeatureFlagService } from 'src/app/shared/services/feature-flag.service';
import { TOTP_CODE_LENGTH } from 'src/app/shared/components/otp-input/otp-input.component';

@Component({
  selector: 'app-two-factor-settings',
  templateUrl: './two-factor-settings.component.html'
})
export class TwoFactorSettingsComponent implements OnInit, OnDestroy {
  static readonly ENFORCED_FLAG = 'TWO_FACTOR_ENFORCED';

  loading = true;
  enabled = false;
  /** Wymuszone globalnie i użytkownik nie jest ADMINem → nie może wyłączyć. */
  disableBlocked = false;
  mode: 'idle' | 'enrolling' | 'disabling' = 'idle';
  disableCode = '';
  disabling = false;

  private flagSubscription: Subscription;

  constructor(
    private authService: AuthService,
    private toastr: ToastrService,
    private featureFlagService: FeatureFlagService
  ) {}

  ngOnInit() {
    this.refresh();
    const isAdmin = this.authService.hasRole(Roles.Admin);
    this.flagSubscription = this.featureFlagService
      .watchFlag(TwoFactorSettingsComponent.ENFORCED_FLAG)
      .subscribe(enforced => { this.disableBlocked = enforced && !isAdmin; });
  }

  ngOnDestroy() {
    if (this.flagSubscription) { this.flagSubscription.unsubscribe(); }
  }

  private refresh() {
    this.loading = true;
    this.authService.getCurrentUserDetails().subscribe((res: any) => {
      this.enabled = !!(res && res.user && res.user.twoFactorEnabled);
      this.loading = false;
    }, () => {
      this.loading = false;
    });
  }

  onEnrolled() {
    this.mode = 'idle';
    this.enabled = true;
    this.toastr.success('Uwierzytelnianie dwuskładnikowe zostało włączone');
  }

  isComplete(code: string): boolean {
    return (code || '').length === TOTP_CODE_LENGTH;
  }

  disable(code: string) {
    if (this.disabling || !this.isComplete(code)) { return; }
    this.disabling = true;
    this.authService.disableTwoFactor(code).subscribe(() => {
      this.disabling = false;
      this.enabled = false;
      this.mode = 'idle';
      this.disableCode = '';
      this.toastr.success('Uwierzytelnianie dwuskładnikowe zostało wyłączone');
    }, (error: HttpErrorResponse) => {
      this.disabling = false;
      this.disableCode = '';
      this.toastr.error(twoFactorErrorMessage(error, 'Nie udało się wyłączyć 2FA (sprawdź kod)'));
    });
  }
}
